module.exports = __webpack_public_path__ + "uia-reveal-it.e5b369ab8c828fdd8c5cf1b836657e5b.svg";